var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('div',[_c('div',{staticClass:"error-code"},[_vm._v("404")]),_c('h1',[_vm._v("Страница не найдена")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }